import {
  NPVR_FETCH_SERIES_LIST_INIT,
  NPVR_FETCH_SERIES_LIST_SUCCESS,
  NPVR_FETCH_SERIES_LIST_ERROR,
  NPVR_FETCH_SERIES_LIST_CLEAR,
} from '../../actions/recording/constants';

const initialState = {
  loading: false,
  data: [],
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case NPVR_FETCH_SERIES_LIST_INIT:
      return { ...state, loading: true, error: null };
    case NPVR_FETCH_SERIES_LIST_SUCCESS:
      return {
        ...state,
        data: [...state.data, ...action.payload],
        loading: false,
        error: null,
      };
    case NPVR_FETCH_SERIES_LIST_ERROR:
      return { ...state, error: action.error };
    case NPVR_FETCH_SERIES_LIST_CLEAR:
      return { ...state, data: [], error: null, loading: false };
    default:
      return state;
  }
};
